import { useTranslation } from 'react-i18next';
import { DateFormats } from 'infrastructure/enums';
import { DateFormatter } from 'infrastructure/functions';

import { ActionsDropdown } from './dropdown';
import s from './styles.module.scss';
import { TemporaryNote } from './temporary-note';

import type { IKeyNoteData } from 'infrastructure/interfaces';

interface IProps {
  keynote: IKeyNoteData;
  onEdit?: () => void;
  onDelete?: () => void;
  onShowHistory?: () => void;
  showActions?: boolean;
}
export const KeyNote = ({
  keynote,
  onDelete,
  onShowHistory,
  onEdit,
  showActions,
}: IProps) => {
  const { t } = useTranslation();
  return (
    <div className={s['key-note-content-wrapper']}>
      <div className={s['key-note-overlay']}>
        <div className={s['actions-by-wrapper']}>
          <div>
            {keynote?.createdAt && keynote?.createdBy && (
              <div data-cy="patient-key-note-updated-by">
                {t('labels.electronicallySignedBy')}: {keynote.createdBy}
                <p className={s['formatted-date']}>
                  {DateFormatter({
                    date: keynote.createdAt,
                    format: DateFormats['MM-dd-yy | h:mm a'],
                  })}
                </p>
              </div>
            )}
            {keynote?.updatedBy && keynote?.updatedAt && (
              <div data-cy="patient-key-note-updated-by">
                {t('labels.lastModifiedBy')}: {keynote.updatedBy}
                <p className={s['formatted-date']}>
                  {DateFormatter({
                    date: keynote.updatedAt,
                    format: DateFormats['MM-dd-yy | h:mm a'],
                  })}
                </p>
              </div>
            )}
          </div>
          {showActions && (
            <ActionsDropdown
              note={keynote}
              onEdit={() => {
                onEdit?.();
              }}
              onShowHistory={() => {
                onShowHistory?.();
              }}
              onDelete={() => {
                onDelete?.();
              }}
            />
          )}
        </div>
        {keynote.expiresAt && <TemporaryNote note={keynote} />}
      </div>
      <div
        data-cy="patient-key-note-content"
        className={s['raw-html']}
        dangerouslySetInnerHTML={{ __html: keynote?.note || '' }}
      />
      <div className={s['edge-wrapper']}>
        <div className={s.edge} />
      </div>
    </div>
  );
};
